<template>
	<div class="" id="getMapLocation">
		<div class="map-container">
			<div id="myMap" class="map-content"></div>
			<div class="search-box">
				<el-input v-model="searchKeyword" placeholder="请搜索地址" @keyup.enter="searchPlace">
					<template #append>
						<el-button type="primary" @click="searchPlace">搜索</el-button>
					</template>
				</el-input>
				<div v-if="searchResults.length > 0" class="search-results">
					<div v-for="(item, index) in searchResults" :key="index" class="result-item"
						@click="selectSearchResult(item)">
						{{ item.name }} - {{ item.address }}
					</div>
				</div>
			</div>
			<div class="location-info" v-if="selectedLocation">
				<p>当前选择位置：{{selectedLocation.work_province}}{{selectedLocation.work_city|cityfilters}}{{selectedLocation.work_county}}</p>
				<p>经度：{{ selectedLocation.work_lng }} 纬度：{{ selectedLocation.work_lat }}</p>
			</div>
		</div>

		<div class="remark">
			<div class="" style="font-weight: 500;font-size: 14px;color: rgb(0, 0, 0);margin-bottom: 10px;">
				详细地址
			</div>
			<div class="" style="color: #606266;font-size: 12px;margin: 5px 0;">

			</div>
			<el-input v-model="remark" maxlength="50" placeholder="如需灵活地描述工作地点，可在此备注。例如：上海、北京设子公司，支持内部调配"></el-input>
		</div>

		<div class="dialog-footer"
			style="margin-top: 20px;display: flex;align-items: center;justify-content: flex-end;">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="sure" :disabled="!remark&&!selectedLocation">
				确定
			</el-button>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex'
	import AMapLoader from '@amap/amap-jsapi-loader'
	import {
		array
	} from 'js-md5'
	import {
		trim
	} from 'jquery'
	let AMap = null



	export default {
		name: 'getMapLocation',
		props: {
			show: {
				type: Boolean,
				default: false
			},
			isjobShadowing: {
				type: Boolean,
				default: false
			},
			addressArr: {
				type: array,
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				dialogVisible: true,
				searchKeyword: '',
				searchResults: [],
				selectedLocation: null,
				placeSearch: null,
				map: null,
				marker: null,
				remark: '',
			}
		},filters:{
			cityfilters(val){
				if(val=='北京市‌'||val=='‌天津市‌‌'||val=='上海市'||val=='重庆市'||val=='澳门特别行政区'||val=='香港特别行政区'){
					return ''
				}
			}
		},
		watch: {
			// show(newValue) {
			// 	if (newValue) {
			// 		this.dialogVisible.value = newValue
			// 	} else {
			// 		this.emit('update', newValue)
			// 	}
			// }
		},
		mounted() {

			this.$nextTick(() => {
				AMapLoader.load({
					key: '743ed98573a8c28909d46bc617af5680', // 使用 JS API key
					version: '2.0'
				}).then((AMap1) => {
					AMap = AMap1
					this.map = new AMap1.Map('myMap', {
						zoom: 11,
						center: [116.397428, 39.90923]
					})
					// 点击地图事件
					// this.map.on('click', async (e) => {
					// 	let lnglat = e.lnglat
					// 	let lnglatArr = [lnglat.lng, lnglat.lat]
					// 	this.updateMarker(lnglatArr)
					// 	this.getAddress(lnglatArr)
					// })
				})
			})
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		destroyed() {
			if (this.map) {
				this.map.destroy()
				this.map = null
			}
			
		},
		methods: {
			updateMarker(lnglat) {

				if (this.marker) {
					this.marker.setPosition(new AMap.LngLat(lnglat[0], lnglat[1]))
				} else {
					this.marker = new AMap.Marker({
						position: new AMap.LngLat(lnglat[0], lnglat[1]),
						map: this.map
					})
				}
			},
			async getAddress(lnglat) {
				this.$util.get1(
					`https://restapi.amap.com/v3/geocode/regeo?key=7a7b4d499ceace8ba5b3824acb3b0344&location=${lnglat[0]},${lnglat[1]}&extensions=base&batch=false&roadlevel=0`, {},
					(res) => {

						let data = res
						if (data.status === '1' && data.info === 'OK') {
							let provincial = data.regeocode.addressComponent.province + data.regeocode
								.addressComponent.city + data.regeocode.addressComponent.district
							this.selectedLocation = {
								formatted_address: data.regeocode.formatted_address,
								address: data.regeocode.formatted_address.replace(provincial, ""),
								work_lng: lnglat[0],
								work_lat: lnglat[1],
								work_city: Array.isArray(data.regeocode.addressComponent.city) ? data.regeocode
									.addressComponent.province : data.regeocode.addressComponent.city,
								work_province: data.regeocode.addressComponent.province,
								work_county: data.regeocode.addressComponent.district,
							}
						} else {

						}
					}
				);
				// try {
				// 	let response = await fetch(
				// 		`https://restapi.amap.com/v3/geocode/regeo?key=${WEBSERVICE_KEY}&location=${lnglat[0]},${lnglat[1]}&extensions=base&batch=false&roadlevel=0`
				// 	)
				// 	let data = await response.json()

				// 	if (data.status === '1' && data.info === 'OK') {
				// 		this.selectedLocation = {
				// 			address: data.regeocode.formatted_address,
				// 			lng: lnglat[0],
				// 			lat: lnglat[1]
				// 		}
				// 	} else {
				// 		
				// 		throw new Error('获取地址失败')
				// 	}
				// } catch (error) {
				// 	
				// }
			},
			selectSearchResult(item) {
				let lnglatArr = [item.location.lng, item.location.lat]
				this.map.setCenter(new AMap.LngLat(lnglatArr[0], lnglatArr[1]))
				this.updateMarker(lnglatArr)

				this.selectedLocation = {
					// address: item.address,
					// lng: lnglatArr[0],
					// lat: lnglatArr[1],
					...item,
				}
				this.remark = item.address
				this.searchResults = [] // 清空搜索结果
			},
			searchPlace() {
				this.searchKeyword = this.searchKeyword.trim()
				if (!this.searchKeyword) {
					this.$message.error('请输入地点搜索');

					return
				}
				this.$util.get1(
					`https://restapi.amap.com/v3/place/text?key=7a7b4d499ceace8ba5b3824acb3b0344&keywords=${encodeURIComponent(this.searchKeyword)}&city=全国&children=1&offset=20&page=1&extensions=base`, {},
					(res) => {

						let data = res
						if (data.status === '1' && data.info === 'OK') {

							if (data.pois.length > 0) {
								this.searchResults = data.pois.map(poi => ({
									name: poi.name,
									address: poi.address,
									formatted_address: poi.pname + poi.cityname + poi.adname + poi.address,
									location: {
										lng: poi.location.split(',')[0],
										lat: poi.location.split(',')[1],
									},
									work_lng: poi.location.split(',')[0],
									work_lat: poi.location.split(',')[1],
									work_city: Array.isArray(poi.cityname) ? poi.pname : poi.cityname,
									work_province: poi.pname,
									work_county: poi.adname,
								}))


							} else {
								this.$message.error('未查询到地点，请重新搜索');
							}
						}
					}
				);
				// try {
				// 	let response = await fetch(
				// 		`https://restapi.amap.com/v3/place/text?key=${WEBSERVICE_KEY}&keywords=${encodeURIComponent(searchKeyword.value)}&city=全国&children=1&offset=20&page=1&extensions=base`
				// 	)

				// 	let data = await response.json()

				// 	if (data.status === '1' && data.info === 'OK') {
				// 		this.searchResults = data.pois.map(poi => ({
				// 			name: poi.name,
				// 			address: poi.address,
				// 			location: {
				// 				lng: poi.location.split(',')[0],
				// 				lat: poi.location.split(',')[1]
				// 			}
				// 		}))
				// 	}
				// } catch (error) {
				// 	
				// }
			},
			handleClose() {
				// this.dialogVisible = false
				this.selectedLocation = null
				this.searchResults = []
				this.searchKeyword = ''
				this.remark = ''
				this.$emit('close')
			},
			sure() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				console.log(this.isjobShadowing)
				if(this.isjobShadowing){
					let selectedLocation = {
						...this.selectedLocation,
						remark:this.remark
					}
					this.$emit('selectLocation',selectedLocation)
					return
				}
				
				let address_arr = JSON.parse(JSON.stringify(this.addressArr))
				if (this.selectedLocation) {
					// this.selectedLocation.remark = this.remark
					// this.$emit('selectLocation', this.selectedLocation)
					let repetitionIndex = -1
					address_arr.forEach((item, index) => {
						if (item.address == this.remark) {
							repetitionIndex = index

						}
					})

					if (repetitionIndex != -1) {
						address_arr.splice(repetitionIndex, 1)

					}

					let obj = {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
					}
					obj.address_arr = JSON.stringify([{
							address: this.remark,
							is_default: 0,
							work_city: this.selectedLocation && this.selectedLocation.work_city ? this
								.selectedLocation.work_city : '',
							work_county: this.selectedLocation && this.selectedLocation.work_county ? this
								.selectedLocation.work_county : '',
							work_lat: this.selectedLocation && this.selectedLocation.work_lat ? this
								.selectedLocation.work_lat : '',
							work_lng: this.selectedLocation && this.selectedLocation.work_lng ? this
								.selectedLocation.work_lng : '',
							work_province: this.selectedLocation && this.selectedLocation.work_province ? this
								.selectedLocation.work_province : '',

							// work_county: this.selectedLocation.work_county||'',
							// work_lat: this.selectedLocation.work_lat||'',
							// work_lng: this.selectedLocation.work_lng||'',
							// work_province: this.selectedLocation.work_province||'',
							remark: this.remark
						},
						...address_arr
					])
					this.$util.post(
						"v2/school_job/editCompany", {
							...obj
						},
						(res) => {

							this.$emit('getCompanyInfo')
						})
				} else {
					let repetitionIndex = -1
					address_arr.forEach((item, index) => {
						if (item.address == this.remark) {
							repetitionIndex = index

						}
					})

					if (repetitionIndex != -1) {
						address_arr.splice(repetitionIndex, 1)

					}
					let selectedLocation = {
						adress: this.remark
					}
					// this.$emit('selectLocation', selectedLocation)
					let obj = {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
					}
					obj.address_arr = JSON.stringify([
						...address_arr,
						{
							address: this.remark,
							is_default: 0,
							work_city: '',
							work_county: '',
							work_lat: '',
							work_lng: '',
							work_province: '',

							// work_county: this.selectedLocation.work_county||'',
							// work_lat: this.selectedLocation.work_lat||'',
							// work_lng: this.selectedLocation.work_lng||'',
							// work_province: this.selectedLocation.work_province||'',
							remark: this.remark
						}
					])
					this.$util.post(
						"v2/school_job/editCompany", {
							...obj
						},
						(res) => {
							this.$emit('getCompanyInfo')
						})
				}
				this.dialogVisible = false
				this.handleClose()

				// else{
				// 	if(this.remark==''){
				// 		 this.$message.error('请选择或手动输入地点');
				// 	}else{
				// 		let selectedLocation = {
				// 			address:this.remark,
				// 			formatted_address:"",
				// 			work_city:"",
				// 			work_county:"",
				// 			work_lat:'',
				// 			work_lng:'',
				// 			work_province:"",
				// 			remark:this.remark
				// 		}
				// 		this.$emit('selectLocation', selectedLocation)
				// 		let repetitionIndex = -1
				// 		address_arr.forEach((item,index)=>{
				// 			if(item.address==selectedLocation.address){
				// 				repetitionIndex = index

				// 			}
				// 		})

				// 		if(repetitionIndex!=-1){
				// 			address_arr.splice(repetitionIndex,1)

				// 		}

				// 		let obj = {
				// 			admin_id: this.schoolInfo.admin_id,
				// 			id: this.schoolInfo.id,
				// 		}
				// 		obj.address_arr = JSON.stringify([
				// 			...address_arr,
				// 			{
				// 				address: this.remark,
				// 				is_default: 0,
				// 				work_city: '',
				// 				work_county: '',
				// 				work_lat: '',
				// 				work_lng: '',
				// 				work_province: '',
				// 				remark:this.remark
				// 			}
				// 		])
				// 		this.$util.post(
				// 			"v2/school_job/editCompany", {
				// 				...obj
				// 			},
				// 			(res) => {

				// 				this.$emit('getCompanyInfo')
				// 			})
				// 	}

				// }

			},
		},
	}
</script>
<style>
	#getMapLocation .el-input-group__append {
		color: #fff !important;
		background: #1E40AF !important;
		border: 1px solid #1E40AF !important;
	}
</style>
<style lang="less" scoped>
	.map-container {
		position: relative;
		width: 100%;
		height: 400px;
	}

	.map-content {
		width: 100%;
		height: 100%;
	}

	.search-box {
		position: absolute;
		top: 10px;
		left: 10px;
		width: 300px;
		z-index: 1;
	}

	.search-results {
		background: white;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		margin-top: 4px;
		max-height: 200px;
		overflow-y: auto;
	}

	.result-item {
		padding: 8px 12px;
		cursor: pointer;

		&:hover {
			background-color: #f5f7fa;
		}
	}

	.location-info {
		position: absolute;
		bottom: 10px;
		left: 10px;
		right: 10px;
		background: white;
		padding: 10px;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		z-index: 99999;

		p {
			margin: 5px 0;
		}
	}


	.remark {
		margin-top: 30px;
	}
</style>